import * as Yup from 'yup';

export const updateUsernameSchema = Yup.object().shape({
    userName: Yup.string().required('Username is required')
});
